export const CONFIG = {
    brandName: "Daily Gospel Network Plus",
    tab1: "Create New Schedule",
    tab2: "View Schedules",
    BASE_URL: "https://li66x5yfyf.execute-api.ap-south-1.amazonaws.com",
    overlapError: "Schedule Overlapping",
    BASE_URL_TEMP: "https://li66x5yfyf.execute-api.ap-south-1.amazonaws.com"
};
